export interface PartOneBasicDetails {
  training_city: string[];
  addressLine1: string;
  addressLine2: string;
  city: string;
  dob: string;
  email: string;
  ethnicHeritage: string[];
  ethnicHeritageNotListed: string;
  firstName: string;
  gender: string;
  lastName: string;
  otherName: string;
  phone: number;
  preferredName: string;
  servedAsMilitay: boolean;
  socialSecurityNumber: string;
  state: string;
  zip: string;
  fullName: string;
  fullAddress: string;
}

export interface User {
  addressLine1?: any;
  addressLine2?: any;
  city: string;
  state: string;
  zip?: any;
  displayName: string;
  email: string;
  firstName: string;
  lastName: string;
  tenantId: string;
  userId: string;
  roles: string[];
  phoneNumber?: any;
  dob?: any;
  thumbnail?: any;
  optIn?: any;
  optInSetting?: any;
  secondaryEmail?: any;
}

export interface attachment {
  files: any[];
  payloadName: string;
}

export interface filesAttachment {
  originalFileName: string;
  type: string;
  uploadedFileName: string;
  width: number;
  height: number;
}

export interface applicationStatusHistory {
  createdAt: string;
  firstName: string;
  lastName: string;
  status: string;
  userId: string;
}

export interface applicationEditHistory {
  mainLabel: string;
  changesData?: editChangesData[];
  trainingLists?: renewalTrainingHistory[];
}

export interface renewalTrainingHistory {
  trainingName: string;
  indexPosition: any;
  isRemoved: boolean;
  isNewlyAdded: boolean;
  changesData: editChangesData[];
}

export interface editHistoryData {
  changesCount: number;
  comment: string;
  dateTime: string;
  editorName: string;
  editorUserId: string;
  data: applicationEditHistory[];
}

export interface editChangesData {
  editDataTime: string;
  editorDetails: {
    email: string;
    name: string;
    userId: string;
  };
  fieldName: string;
  label: string;
  mainLabel: string;
  newValue: any;
  oldValue: any;
  parentName: string;
  isRemoved: boolean;
  isNewlyAdded: boolean;
  index: number;
}

export interface scoredData {
  parentSlug: string;
  scored: [
    {
      key: string;
      points: number;
    }
  ];
  scoredPoints: number;
}

export enum STATUS {
  accepted = "ACCEPTED",
  notAccepted = "NOT ACCEPTED",
  completed = "COMPLETED",
  processing = "PROCESSING",
  inProgress = "INPROGRESS",
  needMoreInfo = "NEED MORE INFO",
  received = "RECEIVED",
  pending = "PENDING",
  waitingForTraining = "WAITING FOR TRAINING",
  completedTraining = "COMPLETED TRAINING",
}

export interface fileValidation {
  name: string;
  veeValidate: string;
}

export interface OfflineFormData {
  id: string;
  attributes: formAttrubutes;
}

export interface formAttrubutes {
  parent_slug: string;
  form_fields: {
    formInupts: [formInputs[] | []];
  };
  form_name: string;
}

export interface formInputs {
  name: string;
  class: string;
  mainClass: string;
  field: string;
  label: string;
  propBind: {
    type: string;
    eventName: string;
  };
  validate: {
    name: string;
    required: boolean;
    veeValidate: string;
    maxLength: number;
  };
  fileValid: {
    name: string;
    veeValidate: string;
  };
}

export interface navList {
  // Array of object Interface
  [index: number]: {
    name: string;
    icon_class: string;
    url: string;
    visible: boolean;
  };
}

export interface dateRange {
  startDate: any;
  endDate: any;
}

export interface filters {
  limit: number;
  offset: number;
}

export interface options {
  name: string;
  value: any[];
  class: string;
  label: string;
}

export interface reviewerDataTable {
  [x: string]: any;
  certificateNumber?: string;
  certifiedAt?: string;
  submittedMode: string;
  createdAt: string;
  id: string;
  code: string;
  firstName: string;
  lastName: string;
  email: string;
  data: any;
  progressStatus: string;
  fillStatus: string;
  action?: boolean;
  rubric: string;
  comment: string;
  userTask: [
    {
      createdAt: string;
      status: string;
      userId: string;
    }
  ];
}

export interface certificationDetails {
  file: File[];
  certificateNumber?: string;
  applicationId: string;
}

export interface docLibraryData {
  attributes: {
    keyName: string;
    documentName: string;
    document: {
      data: {
        attributes: {
          hash: string;
          mime: string;
          name: string;
          provider: string;
          url: string;
        };
      };
    };
  };
}
